import { Dimensions } from "react-native";

let lastPx = 0;
const QUERY_LIST = [960, 1024, 1280, 1366, 1440, 1680, 1920].reverse();

setRootFontSize(getRootFontSize());

Dimensions.addEventListener("change", function () {
  const px = getRootFontSize();
  if (px != lastPx) {
    lastPx = px;
    setRootFontSize(px);
  }
});

function getRootFontSize() {
  let px = 1;

  // const { width } = Dimensions.get("window");
  // const matched = QUERY_LIST.find((q) => width > q);
  // if (matched) {
  //   px = matched / 960;
  // }

  return px;
}

function setRootFontSize(px: number) {
  try {
    document.documentElement.style.fontSize = `${px}px`;
  } catch (error) {
    console.warn(error);
  }
}
